import { useState } from 'react';
import { CheckCircle, Copy, Check, Plus, X } from 'lucide-react';

interface SuccessModalProps {
  shortUrl: string;
  onClose: () => void;
  onCreateNew: () => void;
}

export function SuccessModal({ shortUrl, onClose, onCreateNew }: SuccessModalProps) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shortUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center p-4 z-50">
      <div className="bg-slate-900 rounded-xl border border-slate-800 p-8 max-w-md w-full relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-white transition"
          type="button"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-emerald-500 to-blue-500 rounded-full mb-4">
            <CheckCircle className="w-10 h-10 text-white" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Link Berhasil Dibuat!</h2>
          <p className="text-slate-400 text-sm">
            Link affiliate Anda sudah siap untuk dibagikan
          </p>
        </div>

        <div className="mb-6 bg-slate-800 rounded-lg p-4 border border-slate-700">
          <label className="block text-xs font-medium text-slate-400 mb-2">
            SHORT URL
          </label>
          <div className="flex items-center gap-2">
            <input
              type="text"
              value={shortUrl}
              readOnly
              className="flex-1 bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={copyToClipboard}
            className="flex-1 bg-gradient-to-r from-emerald-600 to-blue-600 hover:from-emerald-700 hover:to-blue-700 text-white font-semibold py-3 rounded-lg transition-all duration-200 shadow-lg shadow-emerald-500/25 flex items-center justify-center gap-2"
          >
            {copied ? (
              <>
                <Check className="w-5 h-5" />
                Copied!
              </>
            ) : (
              <>
                <Copy className="w-5 h-5" />
                COPY
              </>
            )}
          </button>
          <button
            onClick={() => {
              onCreateNew();
              onClose();
            }}
            className="flex-1 bg-slate-800 hover:bg-slate-700 text-white font-semibold py-3 rounded-lg transition flex items-center justify-center gap-2"
          >
            <Plus className="w-5 h-5" />
            Create New
          </button>
        </div>
      </div>
    </div>
  );
}
